/* jshint esversion:11 */
/* jshint loopfunc:true */

document.addEventListener("DOMContentLoaded", function () {
    const widget = document.querySelector(".activity-calendar-widget");
    if (!widget) return;
    
    const daysContainer = widget.querySelector(".activity-calendar-days");
    const monthEl = widget.querySelector(".month");
    const yearEl = widget.querySelector(".year");
    const prevBtn = widget.querySelector(".activity-calendar-nav.prev");
    const nextBtn = widget.querySelector(".activity-calendar-nav.next");

    const today = new Date();
    let selectedDate = new Date(today);
    let viewStart = new Date(today);
    const maxDate = new Date(today.getFullYear(), today.getMonth() + 3, 0);

    const modalEl = widget.querySelector(".modal");
    if (modalEl) document.body.appendChild(modalEl);
    const modalInstance = modalEl ? new bootstrap.Modal(modalEl) : null;

    function formatDate(d) {
        return d.getFullYear() + '-' +
            String(d.getMonth() + 1).padStart(2, '0') + '-' +
            String(d.getDate()).padStart(2, '0');
    }

    function getDaysToShow() {
        return window.innerWidth >= 992 ? 7 : 1;
    }

    function difficultyLabel(value) {
        const n = parseInt(value, 10);
        if (n === 0) return 'All Levels';
        if (n === 1) return 'Low Intensity';
        if (n === 2) return 'Moderate Intensity';
        return 'High Intensity';
    }

    function applyFilter(needle) {
        const dropdown = widget.querySelector(".activity-classTypeFilter");
        if (!dropdown) return;
        for (const option of dropdown.options) {
            if (option.value.toLowerCase() === needle || option.text.toLowerCase() === needle) {
                dropdown.value = option.value;
                break;
            }
        }
        loadDayContent(selectedDate);
    }

    function openActivityModal(eventEl) {
        if (!modalEl || !modalInstance) return;

        const label          = eventEl.dataset.label || 'TBD';
        const instructorName = eventEl.dataset.instructorName || 'TBD';
        const instructorUrl  = eventEl.dataset.instructorUrl || '';
        const difficulty     = eventEl.dataset.difficulty;
        const studio         = eventEl.dataset.studio;

        modalEl.querySelector(".modal-title").textContent = label;

        const instructorEl = modalEl.querySelector(".activity-modal-instructor");
        if (instructorUrl) {
            instructorEl.innerHTML = `<a href="${instructorUrl}" target="_blank" class="text-main-shade">${instructorName}</a>`;
        } else {
            instructorEl.textContent = instructorName;
        }

        modalEl.querySelector(".activity-modal-difficulty").textContent = difficultyLabel(difficulty);

        modalEl.querySelector(".activity-modal-studio").textContent = studio;

        const descWrap   = modalEl.querySelector(".activity-modal-description-wrap");
        const descEl     = modalEl.querySelector(".activity-modal-description");
        const descSource = eventEl.querySelector(".activity-calendar-event-description");
        if (descSource) {
            descEl.innerHTML = descSource.innerHTML;
            descWrap.style.display = 'block';
        } else {
            descEl.innerHTML = '';
            descWrap.style.display = 'none';
        }

        modalInstance.show();
    }

    widget.addEventListener("click", function (e) {
        const trigger = e.target.closest(".activity-calendar-event-trigger");
        if (!trigger) return;
        const eventEl = trigger.closest(".activity-calendar-event");
        if (!eventEl) return;
        openActivityModal(eventEl);
    });

    document.addEventListener("click", function (e) {
        const link = e.target.closest("a[href]");
        if (!link) return;

        const linkUrl = new URL(link.href, window.location.href);

        if (linkUrl.pathname !== window.location.pathname) return;

        const filterParam = linkUrl.searchParams.get("classFilter");
        if (!filterParam) return;

        e.preventDefault();

        applyFilter(filterParam.trim().toLowerCase());

        widget.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    function render() {
        const daysToShow = getDaysToShow();
        daysContainer.innerHTML = '';

        const lastVisible = new Date(viewStart);
        lastVisible.setDate(viewStart.getDate() + daysToShow - 1);
        if (!selectedDate || selectedDate < viewStart || selectedDate > lastVisible) {
            selectedDate = new Date(viewStart);
        }

        if (daysToShow === 1) {
            const options = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };
            monthEl.textContent = selectedDate.toLocaleDateString('default', options);
            yearEl.textContent = '';
        } else {
            const startMonth = viewStart.getMonth();
            const startYear = viewStart.getFullYear();
            const endMonth = lastVisible.getMonth();
            const endYear = lastVisible.getFullYear();

            if (startMonth === endMonth && startYear === endYear) {
                monthEl.textContent = `${viewStart.toLocaleString('default', { month: 'long' })} ${startYear}`;
            } else {
                const startMonthName = viewStart.toLocaleString('default', { month: 'long' });
                const endMonthName = lastVisible.toLocaleString('default', { month: 'long' });
                monthEl.textContent = `${startMonthName} ${startYear} - ${endMonthName} ${endYear}`;
            }
            yearEl.textContent = '';
        }

        if (daysToShow > 1) {
            daysContainer.style.display = 'flex';
            for (let i = 0; i < daysToShow; i++) {
                const date = new Date(viewStart);
                date.setDate(viewStart.getDate() + i);

                const col = document.createElement("div");
                col.className = "col-auto text-center flex-grow-1";

                const dayBtn = document.createElement("button");
                dayBtn.type = "button";
                dayBtn.classList.add("activity-calendar-day", "w-100", "p-1", "d-flex", "flex-column", "align-items-start");
                dayBtn.dataset.date = formatDate(date);
                dayBtn.setAttribute('aria-label', date.toDateString());

                const weekdayLabel = document.createElement("span");
                weekdayLabel.textContent = date.toLocaleString('default', { weekday: 'short' });

                const dayNumber = document.createElement("span");
                dayNumber.className = "h4 mb-0 day-number";
                dayNumber.textContent = String(date.getDate()).padStart(2, '0');

                dayBtn.appendChild(weekdayLabel);
                dayBtn.appendChild(dayNumber);

                if (date.toDateString() === today.toDateString()) dayBtn.classList.add("today");
                if (date.toDateString() === selectedDate.toDateString()) dayBtn.classList.add("selected");

                if (date > maxDate) {
                    dayBtn.disabled = true;
                    dayBtn.classList.add("disabled");
                } else {
                    dayBtn.addEventListener("click", () => {
                        selectedDate = new Date(date);
                        render();
                        loadDayContent(date);
                    });
                }

                col.appendChild(dayBtn);
                daysContainer.appendChild(col);
            }
        } else {
            daysContainer.style.display = 'none';
        }

        prevBtn.disabled = viewStart <= today;
        nextBtn.disabled = lastVisible >= maxDate;

        loadDayContent(selectedDate);
    }

    function loadDayContent(date) {
        const dayName = date.toLocaleString('default', { weekday: 'long' }).toLowerCase();
        const dayKey = formatDate(date);
        const allEvents = widget.querySelectorAll(".activity-calendar-event");
    
        let activeClassFilter = null;
        const dropdown = widget.querySelector(".activity-classTypeFilter");
        if (dropdown) {
            activeClassFilter = dropdown.value.toLowerCase();
            if (activeClassFilter === "all") activeClassFilter = null;
        }
    
        let anyVisible = false;
        let specialVisible = false;
        let recurringVisible = false;
    
        allEvents.forEach(ev => {
            const matchesDay = ev.dataset.day === dayName || ev.dataset.day === dayKey;
            const matchesClass = !activeClassFilter || ev.dataset.classId.toLowerCase() === activeClassFilter;
    
            if (matchesDay && matchesClass) {
                ev.style.display = "block";
                anyVisible = true;
    
                if (ev.dataset.type === "special") specialVisible = true;
                if (ev.dataset.type === "recurring") recurringVisible = true;
            } else {
                ev.style.display = "none";
            }
        });
    
        const specialHeader = document.getElementById("special-events-header");
        const recurringHeader = document.getElementById("recurring-events-header");
    
        if (specialHeader) specialHeader.style.display = specialVisible ? "block" : "none";
    
        if (recurringHeader) {
            recurringHeader.style.display = recurringVisible ? "block" : "none";
    
            if (!specialVisible) {
                recurringHeader.classList.remove("mt-2");
            } else {
                recurringHeader.classList.add("mt-2");
            }
        }
    
        let noEventsRow = widget.querySelector(".activity-calendar-no-events");
        if (!noEventsRow) {
            const container = widget.querySelector(".activity-calendar-content");
            noEventsRow = document.createElement("div");
            noEventsRow.className = "activity-calendar-no-events text-muted pt-2";
            noEventsRow.textContent = "No activities for this day.";
            container.appendChild(noEventsRow);
        }
        noEventsRow.style.display = anyVisible ? "none" : "block";
    }

    function goPrev() {
        viewStart.setDate(viewStart.getDate() - 1);
        if (viewStart < today) viewStart.setTime(today.getTime());
        render();
    }

    function goNext() {
        viewStart.setDate(viewStart.getDate() + 1);
        const daysToShow = getDaysToShow();
        const lastVisible = new Date(viewStart);
        lastVisible.setDate(viewStart.getDate() + daysToShow - 1);
        if (lastVisible > maxDate) viewStart.setDate(maxDate.getDate() - daysToShow + 1);
        render();
    }

    const dropdown = widget.querySelector(".activity-classTypeFilter");

    if (dropdown) {
        let needle = null;

        const parts = window.location.pathname.split('/');
        const keyIndex = parts.findIndex(p => p.toLowerCase() === 'classfilter');
        if (keyIndex !== -1 && parts[keyIndex + 1]) {
            needle = decodeURIComponent(parts[keyIndex + 1]).toLowerCase();
        }

        if (!needle) {
            const qsValue = new URLSearchParams(window.location.search).get('classFilter');
            if (qsValue) needle = qsValue.trim().toLowerCase();
        }

        if (needle) applyFilter(needle);

        dropdown.addEventListener("change", () => {
            loadDayContent(selectedDate);
        });
    }

    prevBtn.addEventListener("click", (e) => { e.preventDefault(); goPrev(); });
    nextBtn.addEventListener("click", (e) => { e.preventDefault(); goNext(); });

    window.addEventListener("resize", render);
    render();
});